<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1"> </span></p>
<p class="p1"><span class="t1"> </span></p>
<p class="p2"><span class="t2">Tortilla Pie</span></p>
<p class="p2"><span class="t3">The Recipe for Romance</span></p>
<p class="p2"><span class="t4">Rick R. Reed</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?3c770963